import { Pill } from "components/ui/Pill";
import style from "features/cdm/components/PreviewContent/previewContent.module.css";

const getHealthlinkStatusColors = (status) => {
  if (!status) return { color: "#717186", bg: "#f3f4f6", border: "#d1d5db" };
  const upper = status.toUpperCase();
  if (upper === "SUBMITTED" || upper === "ACKNOWLEDGED" || upper === "ACCEPTED")
    return { color: "#006546", bg: "#e7efeb", border: "#006546" };
  if (upper === "FAILED" || upper === "REJECTED")
    return { color: "#b70000", bg: "#ffe8e8", border: "#b70000" };
  return { color: "#717186", bg: "#f3f4f6", border: "#d1d5db" };
};

const formatStatus = (status) => {
  if (!status) return "-";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

const Section = ({ title, children }) => (
  <>
    <h4 className={style.sectionHeader}>{title}</h4>
    {children}
  </>
);

export const CdmPreviewContent = ({ data }) => {
  const hasHealthlink =
    data.clinicalMessageStatus ||
    data.clinicalMessageControlId ||
    data.reimbursementMessageControlId;

  if (!hasHealthlink) return null;

  return (
    <div className={style.contentArea}>
      <div className={style.contentBox}>
        <Section title="Healthlink Submission Status">
          <div className={style.healthlinkStatusGrid}>
            {data.clinicalMessageStatus && (
              <div className={style.healthlinkStatusField}>
                <span className={style.healthlinkStatusLabel}>Status:</span>
                <Pill {...getHealthlinkStatusColors(data.clinicalMessageStatus)}>
                  {formatStatus(data.clinicalMessageStatus)}
                </Pill>
              </div>
            )}
            {data.consultationDate && (
              <div className={style.healthlinkStatusField}>
                <span className={style.healthlinkStatusLabel}>Submitted:</span>
                <span className={style.healthlinkStatusValue}>
                  {data.consultationDate}
                </span>
              </div>
            )}
          </div>
          {(data.clinicalMessageControlId ||
            data.reimbursementMessageControlId) && (
            <div className={style.messageIdRow}>
              <span className={style.healthlinkStatusLabel}>Message ID:</span>
              <span className={style.messageIdValue}>
                {[data.clinicalMessageControlId, data.reimbursementMessageControlId]
                  .filter(Boolean)
                  .join(" / ")}
              </span>
            </div>
          )}
        </Section>
      </div>
    </div>
  );
};
